/*
  Custom theme tweaks (vanilla JS).
  Replaces old jQuery-only implementation to avoid loading jQuery sitewide.
*/

(function () {
  function closest(el, selector) {
    while (el && el.nodeType === 1) {
      if (el.matches(selector)) return el;
      el = el.parentElement;
    }
    return null;
  }

  function hideAllDropdowns() {
    document.querySelectorAll('.cus_select .select_ul_div.show_ul').forEach(function (d) {
      d.classList.remove('show_ul');
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    var selects = Array.prototype.slice.call(document.querySelectorAll('.cus_select'));
    if (!selects.length) return;

    // Desktop hover support
    selects.forEach(function (wrap) {
      wrap.addEventListener('mouseenter', function () {
        var dd = wrap.querySelector('.select_ul_div');
        if (dd) dd.classList.add('show_ul');
      });
      wrap.addEventListener('mouseleave', function () {
        var dd = wrap.querySelector('.select_ul_div');
        if (dd) dd.classList.remove('show_ul');
      });

      // Mobile/touch: toggle on click
      wrap.addEventListener('click', function (e) {
        // If user clicks inside dropdown list itself, don't toggle.
        if (closest(e.target, '.select_ul_div')) return;

        var dd = wrap.querySelector('.select_ul_div');
        if (!dd) return;

        var willShow = !dd.classList.contains('show_ul');
        hideAllDropdowns();
        if (willShow) dd.classList.add('show_ul');
      });
    });

    // Click outside closes
    document.addEventListener('click', function (e) {
      if (!closest(e.target, '.cus_select')) hideAllDropdowns();
    });

    // ESC closes
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') hideAllDropdowns();
    });
  });
})();
